const templateVariables = {
  name: "libraryMainsite-1.3.1",
  locate: "vn",
  folderUse: ["main"],
  generateFile: ["frame1"],
  H5: true,
  onlyPC: false,
  scaleWidthPC: 0,
  scaleWidthMB: 0,
  scssVariable: {
    minWidthPC: "0",
    maxWidthMB: "0",
  },
};

module.exports = templateVariables;
